import * as types from "./actionTypes";

export const getListRequest =() =>{
    return {
        type: types.DEFAULT_CONSTRUCTION_PHASE_LIST_REQUEST
    }
};
export const getListSuccess =(data) =>{
    return {
        type: types.DEFAULT_CONSTRUCTION_PHASE_LIST_SUCCESS,
        payLoad:data
    }
};
export const getListFailure =(data) =>{
    return {
        type: types.DEFAULT_CONSTRUCTION_PHASE_LIST_FAILURE
    }
};

export const storeRequest = data => {
    return{
        type: types.DEFAULT_CONSTRUCTION_PHASE_STORE_REQUEST,
        data: {
            construction_phase_ids: data
        }
    }
};
export const storeSuccess = data => {
    return{
        type: types.DEFAULT_CONSTRUCTION_PHASE_STORE_SUCCESS,
        payLoad: data
    }
};
export const storeFailure = () => {
    return{
        type: types.DEFAULT_CONSTRUCTION_PHASE_STORE_FAILURE
    }
};